let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4naQb")).then(() => parcelRequire('7WEkG'));